import React from 'react'
import "./Education.css"

function Education() {
  return (
    <div className="education-section" >

        <span className='education-inner ' data-aos="fade-out" >
        <span data-aos="fade-in"> <b>primary School </b>={'>'} Ibn Ataa Alah Language School </span>
        <span data-aos="fade-in">  <b>Middel School </b> ={'>'} Ibn Ataa Alah Language School</span>
        <span data-aos="fade-in"> <b> Secondary School </b>  ={'>'} Ibn Ataa Alah Language School</span>
        <span data-aos="fade-in"> <b>College</b>  ={'>'} Computer and information Helwan Uni , software engineering Dept.</span>

        </span>
    </div>
  )
}

export default Education